import { globals } from "../../globals";
import { logOut } from "./auth";
import moment from 'moment';
//const history = createBrowserHistory();
// ------------------------------------
// Constants
// ------------------------------------
export const GET_INTRANET_DASHBOARD_START = "GET_INTRANET_DASHBOARD_START";
export const GET_INTRANET_DASHBOARD_SUCCESS = "GET_INTRANET_DASHBOARD_SUCCESS";
export const GET_INTRANET_DASHBOARD_FAILED = "GET_INTRANET_DASHBOARD_FAILED";
// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  "Content-Type": "application/json",
};

export function getIntranetDashboard() {
  return (dispatch) => {
    dispatch({ type: GET_INTRANET_DASHBOARD_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({}),
    };

    fetch(`${globals.apiUrl}/outlookreport/runreport`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } 
        else if (response.status === 401) {
          dispatch(logOut());
        } 
        else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_INTRANET_DASHBOARD_FAILED, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_INTRANET_DASHBOARD_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_INTRANET_DASHBOARD_FAILED });
      });
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_INTRANET_DASHBOARD_START]: (state) => {
    return {
      ...state,
      isFetchingDashboard: true,
    };
  },
  [GET_INTRANET_DASHBOARD_FAILED]: (state) => {
    return {
      ...state,
      isFetchingDashboard: false,
    };
  },
  [GET_INTRANET_DASHBOARD_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isFetchingDashboard: false,
      formDataValue: {
        report: json.data,
        updateDate: moment(json.updateDate).format('MM/DD/YYYY hh:mm A'),
      },
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  renderData: {},
  formDataValue: {
    report: [],
    // updateDate: new Date(),
    updateDate: moment().format('MM/DD/YYYY hh:mm A'),
    isFetchingDashboard: true
  },
};

export default function intranetDashboardReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}




// WEBPACK FOOTER //
// ./src/store/reducers/intranetDashboard.js